// Joins a brand's product facts (shared with brand-config-be) to its frontend-only config.
export function withBrandProduct({ identity, ...productConfig }, { constants, theme, config }) {
    return { constants: { ...identity, ...constants }, theme, config: { ...productConfig, ...config } };
}
